import { forwardRef, type MouseEventHandler, type ReactNode } from 'react';
import MuiButton from '@mui/material/Button';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { Loader } from '../Loader';

export type ButtonShape = 'pill' | 'square';

export type ButtonProps = {
  children?: ReactNode;
  variant?: MuiButtonProps['variant'];
  color?: MuiButtonProps['color'];
  size?: MuiButtonProps['size'];
  shape?: ButtonShape;
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  type?: 'button' | 'submit' | 'reset';
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    children,
    variant = 'contained',
    color = 'primary',
    size = 'medium',
    shape = 'pill',
    loading = false,
    startIcon,
    endIcon,
    disabled,
    fullWidth = true,
    type = 'button',
    onClick
  },
  ref
) {
  const resolvedDisabled = disabled || loading;
  const disableRipple = variant === 'text';
  return (
    <MuiButton
      ref={ref}
      type={type}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      disabled={resolvedDisabled}
      disableRipple={disableRipple}
      onClick={onClick}
      {...(shape === 'square' ? { className: 'SmButton-shape-square' } : {})}
      startIcon={loading ? <Loader size={16} thickness={5} color="inherit" /> : startIcon}
      endIcon={endIcon}
    >
      {children}
    </MuiButton>
  );
});
